import { render } from "./BidsManager.vue?vue&type=template&id=3d58e34f&scoped=true&lang=pug"
import script from "./BidsManager.vue?vue&type=script&lang=ts"
export * from "./BidsManager.vue?vue&type=script&lang=ts"

import "./BidsManager.vue?vue&type=style&index=0&id=3d58e34f&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3d58e34f"

export default script